<template>
  <v-dialog v-model="addDialog" class="the-app-dialogs" persistent max-width="800px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit()">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">attach_money</v-icon>
              <span class="px-3">{{ $t('Add Remittance Office') }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="headline no-select pb-1">
              <v-layout justify-end></v-layout>
            </v-flex>

            <v-layout row wrap>
              <v-flex xs12 sm12 md12 class="py-1 px-2">
                <v-text-field
                  id="remittance-focus-me"
                  v-model="form.remittance_office_name"
                  :label="`${$t('Name')} *`"
                  name="Name"
                  hide-details
                  box
                  background-color="white"
                  :error="errors.has('Name')"
                  v-validate="'required'"
                />
              </v-flex>
              <v-flex xs6 sm6 md6 pa-2>
                <v-text-field
                  v-model="form.remittance_office_phone"
                  :label="$t('Phone Number')"
                  name="Phone Number"
                  hide-details
                  box
                  background-color="white"
                />
              </v-flex>

              <v-flex xs6 sm6 md6 pa-2>
                <v-text-field
                  v-model="form.remittance_office_mail"
                  :label="$t('Email')"
                  name="Email"
                  hide-details
                  box
                  data-vv-validate-on="blur"
                  background-color="white"
                  :error="errors.has('Email')"
                  v-validate="'email'"
                />
              </v-flex>
              <v-flex xs6 sm6 md6 pa-2>
                <v-text-field
                  v-model="form.remittance_office_address"
                  :label="$t('Address')"
                  name="Address"
                  hide-details
                  box
                  background-color="white"
                />
              </v-flex>

              <v-flex xs6 sm6 md6 pa-2>
                <v-autocomplete
                  :items="this.$vuetify.rtl ? fullCountriesListAr : fullCountriesListEn"
                  v-model="form.remittance_office_country"
                  :label="$t('Country')"
                  box
                  hide-details
                  data-vv-name="Country"
                  :menu-props="{ transition: 'slide-y-transition' }"
                  background-color="white"
                />
              </v-flex>
              <v-flex xs6 sm6 md6 pa-2>
                <v-text-field
                  v-model="form.remittance_office_governorate"
                  :label="$t('Governorate')"
                  name="Governorate"
                  hide-details
                  box
                  background-color="white"
                />
              </v-flex>

              <v-flex xs6 sm6 md6 pa-2>
                <v-text-field
                  v-model="form.remittance_office_city"
                  :label="$t('City')"
                  name="City"
                  hide-details
                  box
                  background-color="white"
                />
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card-title>
        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end align-center pr-2 pl-2>
              <v-checkbox color="primary" v-model="keepForm" :label="$t('Keep this form to add another one.')" />

              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :loading="btnAddLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Add') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'add-component',

  props: {
    addDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      btnAddLoading: false,
      form: {},
      keepForm: false
    }
  },

  computed: {
    ...mapGetters({
      fullCountriesListEn: 'countries/getFullCountriesListEn',
      fullCountriesListAr: 'countries/getFullCountriesListAr'
    })
  },

  watch: {
    addDialog: {
      immediate: false,
      handler() {
        if (this.addDialog) {
          this.addEscKeyListener()
          this.resetForm()
          this.keepForm = false
        }
      }
    }
  },

  methods: {
    ...mapActions({
      addRemittanceOffice: 'remittances/addRemittanceOffice'
    }),

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the "ESC" button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.addDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    resetForm() {
      this.$validator.pause()
      for (let key in this.form) {
        this.form[`${key}`] = null
      }
      this.$nextTick(() => {
        this.$validator.resume()
        // default veutify autofocus only one time works so we have to handled in this way.
        // document.getElementById('remittance-focus-me').focus()
      })
    },

    validateBeforeSubmit() {
      this.$validator
        .validateAll()
        .then(() => {
          if (!this.errors.any()) {
            this.btnAddLoading = true

            this.addRemittanceOffice(this.form)
              .then(() => {
                this.btnAddLoading = false
                this.$emit('reset-datatable')
                if (this.keepForm) {
                  this.resetForm()
                } else {
                  this.$emit('hidemodal')
                }
              })
              .catch(() => {
                this.btnAddLoading = false
              })
          }
        })
        .catch(() => {
          this.btnAddLoading = false
        })
    }
  }
}
</script>

<style scoped />
